import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("wp_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch((err) => {
      if (err.response?.status === 401) {
        localStorage.removeItem("wp_token");
      }
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("wp_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (data) => {
    const r = await api.post("/auth/register", data);
    localStorage.setItem("wp_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("wp_token");
    setUser(null);
  };

  const switchWedding = async (weddingId) => {
    await api.put("/users/active-wedding", { wedding_id: weddingId });
    setUser(prev => ({ ...prev, active_wedding_id: weddingId }));
    window.location.reload();
  };

  return <AuthCtx.Provider value={{ user, login, register, logout, switchWedding, loading }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
